import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import OutsideClickHandler from 'react-outside-click-handler';
import { Block, Tag, Label, Circle } from '../../..';
import { Item, RightPanelContent, WrapCourseDetail } from './styled';
import CourseDetail from '../CourseDetail';
import icon from '../../../../../assets/icons/iconVirtual.svg';
import Icon from '../../../Icon';
import IDHelpers from '../../../../../core/helpers/IDHelper';
import TextHelper from '../../../../../core/helpers/TextHelper';
import { GlobalStyles } from '@/presentation/components/LightBox';
import { FixedMainLayoutStyles } from '@/presentation/modules/schedule/ScheduleView';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

interface IRightPanelProps {
  count: number;
  openVirtual: boolean;
}

interface ILeftPanelProps {
  count: number;
  openVirtual: boolean;
}

export const RightPanel = ({ count, openVirtual }: IRightPanelProps) => {
  let className = '';
  if (count === 1) className = 'RightPanelOneCourse';
  else className = openVirtual ? 'open' : '';
  return (
    <RightPanelContent
      data-testid="cmp-right-panel-content"
      className={className}
    >
      <>
        <Block flex style={{ alignItems: 'center' }}>
          <Label
            fontWeight="400"
            color="#ffffff"
            size={14}
            text=""
            marginLeft={8}
            marginRight={8}
            lineHeight={20}
          />
          <img src={icon} alt="Logo" />
          <Label
            fontWeight="400"
            color="#fff"
            size={14}
            text="UTP + Class"
            marginLeft={4}
            marginRight={4}
            lineHeight={20}
          />
        </Block>
        {openVirtual && count > 1 && (
          <Block className="buttonChevron">
            <Icon name="chevron-up" size={25} color="#fff" />
          </Block>
        )}
        {!openVirtual && count > 1 && (
          <Block className="buttonChevron">
            <Icon name="chevron-down" size={25} color="#fff" />
          </Block>
        )}
      </>
    </RightPanelContent>
  );
};

export const LeftPanel = ({ count, openVirtual }: ILeftPanelProps) => {
  let className = '';
  if (count === 1) className = 'RightPanelOneCourse';
  else className = openVirtual ? 'open' : '';
  return (
    <RightPanelContent
      // data-testid="cmp-right-panel-content"
      className={className}
    >
      <Block flex style={{ alignItems: 'center' }}>
        <Tag
          backgroundColor="var(--background-tag-background10)"
          color="var(--decorative-decorative01)"
          padding="4px 12px"
          margin="0px 24px 0px 8px"
          size={14}
          bold
          lineHeight={20}
          radius={20}
        >
          <Label
            text="Virtual 24/7"
            bold
            color="var(--decorative-decorative10)"
            size={12}
            lineHeight={16}
          />
        </Tag>
        {count > 1 && (
          <Label
            text={`${count} Cursos`}
            black
            color="#FFFFFF"
            size={14}
            lineHeight={20}
          />
        )}
      </Block>
    </RightPanelContent>
  );
};

export const ItemVirtualCourse = (props: any) => {
  const { course, isLong, index, isMin, count } = props;
  const [detailShow, setDetailShow] = useState(false);

  const handleShowCard = () => {
    GoogleAnalytics.writeLog('portal-schedule-courseCard', 'schedule');
    setDetailShow(true);
  };

  return (
    <Item>
      <button
        type="button"
        data-testid="cmp-button-item"
        className="buttonInteraction fadeTransition"
        style={
          isLong
            ? {
                width: 106,
                padding: count === 1 ? '0px' : '12px 19px 12px 8px',
                paddingTop: isMobile && count === 1 ? '5px' : '12px',
                paddingBottom: isMobile && count === 1 ? '0px' : '12px'
              }
            : {
                width: isMobile && count === 1 ? 160 : '100%',
                padding: isMobile && count === 1 ? '0px' : '12px 19px 12px 8px',
                paddingTop: isMobile && count === 1 ? '5px' : '12px',
                paddingBottom: isMobile && count === 1 ? '0px' : '12px'
              }
        }
        onClick={() => {
          handleShowCard();
        }}
      >
        <Circle color="#ffffff" />
        <Label
          color="#fff"
          className={detailShow ? 'clickable active' : 'clickable'}
          size={14}
          lineHeight={16}
          black
          text={
            !isMobile || !isMin
              ? TextHelper.capitalize(course.name)
              : TextHelper.elipsis(TextHelper.capitalize(course.name), 22)
          }
        />
      </button>
      {detailShow && (
        <div
          style={{
            background: 'rgb(40 48 68 / 60%)',
            position: 'fixed',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 99,
            height: '100%'
          }}
        >
          <GlobalStyles />
          <FixedMainLayoutStyles />
          <OutsideClickHandler
            onOutsideClick={() => {
              setDetailShow(false);
            }}
          >
            <CourseDetail
              contentData={course}
              onClose={() => {
                setDetailShow(false);
                if (isMobile) {
                  const el = document.getElementById('header-wrapper');
                  if (el) el.classList.remove('hide');
                }
              }}
              cardType="V"
              dateEvent={course.start}
              index={index}
              isClass={course?.isClass}
            />
          </OutsideClickHandler>
        </div>
      )}
    </Item>
  );
};

ItemVirtualCourse.defaultProps = {
  course: {},
  isReprogramming: false,
  courseType: 'V',
  isActive: false
};

export const ListVirtualCourses = (props: any) => {
  const { virtualCourses, isClickOut, openVirtual, isClass } = props;

  const isLong = virtualCourses?.length > 5;
  const isMin = virtualCourses?.length === 1;
  const [activeCourse, setActiveCourse] = useState({});
  let className = '';
  if (virtualCourses && virtualCourses.length === 1)
    className = 'WrapCourseDetailOneCourse';
  else className = openVirtual ? 'openVirtual' : '';
  return (
    <WrapCourseDetail
      data-testid="cpm-wrap-course-detail"
      key={IDHelpers.generateID()}
      className={className}
    >
      {virtualCourses &&
        virtualCourses?.map((course: any, index: number) => (
          <ItemVirtualCourse
            key={IDHelpers.generateID()}
            course={course}
            isActive={course.id === activeCourse}
            onClear={() => {
              setActiveCourse({});
            }}
            isLong={isLong}
            isMin={isMin}
            isClickOut={isClickOut}
            index={index}
            count={virtualCourses?.length}
            isClass={isClass}
          />
        ))}
    </WrapCourseDetail>
  );
};
